import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'codeFormat',
  standalone: true
})
export class CodeFormatPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return value;

    value = value.replace(/[^A-Za-z0-9]/g, '');

    if (value.length <= 4) {
      return value;
    } else if (value.length <= 8) {
      return value.replace(/(\w{4})(\w{0,4})/, '$1-$2');
    } else if (value.length <= 12) {
      return value.replace(/(\w{4})(\w{4})(\w{0,4})/, '$1-$2-$3');
    } else {
      return value.replace(/(\w{4})(\w{4})(\w{4})(\w{0,4})/, '$1-$2-$3-$4');
    }
  }

  static format(value: string): string {
    return value.replace(/[^A-Za-z0-9]/g, '');
  }

}
